// extracted by mini-css-extract-plugin
module.exports = {"a15384yj":"a15384yj","s1k9ogns":"s1k9ogns","sdyg7j":"sdyg7j","g10u9umr":"g10u9umr","google-login-btn":"google-login-btn"};